"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _PhoneInput = require("./PhoneInput");
Object.keys(_PhoneInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhoneInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PhoneInput[key];
    }
  });
});
var _PhoneInputConsent = require("./PhoneInputConsent");
Object.keys(_PhoneInputConsent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PhoneInputConsent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PhoneInputConsent[key];
    }
  });
});